/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// @material-ui/core components
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

export default function Example() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={8} lg={6}>
        <CustomDropdown
          dropdownHeader="Dropdown header"
          buttonText="Multilevel Dropdown"
          buttonProps={{
            round: true,
            block: true,
            color: "info",
          }}
          dropPlacement="bottom-start"
          dropdownList={[
            "Action",
            "Another action",
            "Something else here",
            { divider: true },
            "Separated link",
            { divider: true },
            "One more separated link",
            <CustomDropdown
              ref="multi"
              innerDropDown
              buttonText="Submenu"
              buttonProps={{
                simple: true,
                block: true,
              }}
              dropPlacement="right-start"
              dropdownList={[
                "Submenu action",
                "Submenu action",
                <CustomDropdown
                  ref="multi"
                  innerDropDown
                  buttonText="Second submenu"
                  buttonProps={{
                    simple: true,
                  }}
                  dropPlacement="right-start"
                  dropdownList={["Submenu action 1", "Submenu action 2"]}
                />,
              ]}
            />,
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}
